export class AuthInfo {
    constructor(username, permissions) {
        this.username = username;
        this.permissions = permissions;
    }
}

export default class AuthApi {
    async getAuthInfo() {
        try {
            let response = await fetch('rss/api/v3/auth');
            if (response.ok) {
                let data = await response.json();
                return new AuthInfo(data.username, data.permissions);
            }
        } catch {
            return null;
        }
    }
}